import { CustomSelectOption } from 'components/shared/CustomSelect';
import { useI18n } from 'hooks/useI18n';
import { useState } from 'react';
import SectionChart from '../shared/sectionChart/SectionChart';
import Switcher from '../shared/switcher/Switcher';
import RolesDistribution from './charts/RolesDistribution';
import SoftSkillsCommunityVsOffered from './charts/SoftSkillsCommunityVsOffered';
import TalentByTechBackend from './charts/TalentByTechBackend';
import TalentByTechData from './charts/TalentByTechData';
import TalentByTechFrontend from './charts/TalentByTechFrontend';
import TalentByTechInfra from './charts/TalentByTechInfra';
import TalentByTechMobile from './charts/TalentByTechMobile';
import {
  EXPERIENCEBYROLETABS,
  LEASTWANTEDTECHSTABS,
  MOSTUSEDTECHSTABS,
  TALENTBYTECHOPTIONS
} from './Talent.constants';
import { StyledSection } from './Talent.styled';
import { StyledSwitcher } from '../shared/switcher/Switcher.styled';
import RadioButton from 'components/shared/RadioButton';
import SectionHeroBoxes from '../shared/sectionHeroBoxes/SectionHeroBoxes';
import { StyledTableContainer } from './charts/TalentByTech.styled';

const Talent: React.FC = () => {
  const { t } = useI18n('developer-career-report-2025');
  const mostUsedTechTabs = MOSTUSEDTECHSTABS(t);
  const leastWantedTechTabs = LEASTWANTEDTECHSTABS(t);
  const experienceByRoleTabs = EXPERIENCEBYROLETABS(t);
  const talentByTechOptions = TALENTBYTECHOPTIONS(t);

  const [currentOption, setCurrentOption] = useState<string | number>('back');

  const handleOptionChange = ({ value }: CustomSelectOption): void => {
    setCurrentOption(value);
  };

  return (
    <StyledSection>
      <SectionHeroBoxes
        boxOne={{ text: t('mantechcar25.talent.hero.title'), color: '#7eafd3' }}
        boxTwo={{ text: t('mantechcar25.talent.hero.desc'), color: '#312784' }}
        boxThree={{
          text: t('mantechcar25.talent.hero.descExtra'),
          color: '#2171b5',
          textColor: '#fff'
        }}
      />
      <SectionChart
        title={t('mantechcar25.talent.talent-per-tech.title')}
        shareId="talentpertech"
        emailSubject={t(
          'mantechcar25.share-modal.talent-per-tech.email-subject'
        )}
        emailMessage={t('mantechcar25.share-modal.talent-per-tech.email-text')}
        shareMessage={t('mantechcar25.share-modal.talent-per-tech.text')}
      >
        {/* <StyledSelect>
          <CustomSelect
            options={talentByTechOptions}
            defaultValue={talentByTechOptions[0]}
            id="talentByTechSelect"
            onChange={handleOptionChange}
          />
        </StyledSelect> */}
        <StyledSwitcher role="tablist" style={{ marginBottom: 8 }}>
          {talentByTechOptions.map((option, index) => (
            <RadioButton
              key={index}
              name={String(option.label)}
              id={String(option.value)}
              label={option.label}
              aria-controls={option.value + '_content'}
              aria-selected={currentOption === option.value}
              onChange={() => handleOptionChange(option)}
              checked={currentOption === option.value}
            />
          ))}
        </StyledSwitcher>
        <StyledTableContainer>
          {currentOption === 'front' && <TalentByTechFrontend />}
          {currentOption === 'back' && <TalentByTechBackend />}
          {currentOption === 'mobile' && <TalentByTechMobile />}
          {currentOption === 'data' && <TalentByTechData />}
          {currentOption === 'infra' && <TalentByTechInfra />}
        </StyledTableContainer>
      </SectionChart>
      <SectionChart
        title={t('mantechcar25.talent.roles-distribution.title')}
        desc={t('mantechcar25.talent.roles-distribution.desc')}
        descExtra={t('mantechcar25.talent.roles-distribution.descExtra')}
        shareId="rolesdistribution"
        emailSubject={t(
          'mantechcar25.share-modal.roles-distribution.email-subject'
        )}
        emailMessage={t(
          'mantechcar25.share-modal.roles-distribution.email-text'
        )}
        shareMessage={t('mantechcar25.share-modal.roles-distribution.text')}
      >
        <RolesDistribution />
      </SectionChart>
      <SectionChart
        title={t('mantechcar25.talent.most-used-techs.title')}
        desc={t('mantechcar25.talent.most-used-techs.desc')}
        descExtra={t('mantechcar25.talent.most-used-techs.descExtra')}
        shareId="mostusedtechs"
        emailSubject={t(
          'mantechcar25.share-modal.most-used-techs.email-subject'
        )}
        emailMessage={t('mantechcar25.share-modal.most-used-techs.email-text')}
        shareMessage={t('mantechcar25.share-modal.most-used-techs.text')}
      >
        <Switcher
          tabsName={mostUsedTechTabs.tabsName}
          tabs={mostUsedTechTabs.tabs}
        />
      </SectionChart>
      <SectionChart
        title={t('mantechcar25.talent.least-wanted-techs.title')}
        desc={t('mantechcar25.talent.least-wanted-techs.desc')}
        descExtra={t('mantechcar25.talent.least-wanted-techs.descExtra')}
        shareId="leastwantedtechs"
        emailSubject={t(
          'mantechcar25.share-modal.least-wanted-techs.email-subject'
        )}
        emailMessage={t(
          'mantechcar25.share-modal.least-wanted-techs.email-text'
        )}
        shareMessage={t('mantechcar25.share-modal.least-wanted-techs.text')}
      >
        <Switcher
          tabsName={leastWantedTechTabs.tabsName}
          tabs={leastWantedTechTabs.tabs}
        />
      </SectionChart>
      <SectionChart
        title={t('mantechcar25.talent.main-techs.title')}
        desc={t('mantechcar25.talent.main-techs.desc')}
        descExtra={t('mantechcar25.talent.main-techs.descExtra')}
        shareId="experiencebyrole"
        emailSubject={t('mantechcar25.share-modal.main-techs.email-subject')}
        emailMessage={t('mantechcar25.share-modal.main-techs.email-text')}
        shareMessage={t('mantechcar25.share-modal.main-techs.text')}
      >
        <Switcher
          tabsName={experienceByRoleTabs.tabsName}
          tabs={experienceByRoleTabs.tabs}
        />
      </SectionChart>
      <SectionChart
        title={t('mantechcar25.talent.competences.title')}
        desc={t('mantechcar25.talent.competences.desc')}
        descExtra={t('mantechcar25.talent.competences.descExtra')}
        shareId="competences"
        emailSubject={t('mantechcar25.share-modal.competences.email-subject')}
        emailMessage={t('mantechcar25.share-modal.competences.email-text')}
        shareMessage={t('mantechcar25.share-modal.competences.text')}
      >
        <SoftSkillsCommunityVsOffered />
      </SectionChart>
    </StyledSection>
  );
};

export default Talent;
